import React, { useMemo } from "react";
import CrBox from "./crBox/CrBox.tsx";
import { LobbyRefreshData, ConfirmationRequest } from "../../../../types/lobby";
import "./CrStatusList.scss";

interface Props {
  refreshDataMap: Record<string, LobbyRefreshData>;
}

const CrStatusList: React.FC<Props> = ({ refreshDataMap }) => {
  const crByStatus = useMemo(() => {
    const requested: ConfirmationRequest[] = [];
    const checking: ConfirmationRequest[] = [];
    const completed: ConfirmationRequest[] = [];

    Object.values(refreshDataMap).forEach((data) => {
      if (Array.isArray(data.cr)) {
        data.cr.forEach((cr) => {
          const code = String(cr.confirmation_response_cd);
          if (code === "0") requested.push(cr);
          else if (code === "1") checking.push(cr);
          else if (code === "2") completed.push(cr);
        });
      }
    });

    const sortByOccurrenceTime = (
      a: ConfirmationRequest,
      b: ConfirmationRequest
    ) => {
      const dateA = new Date(a.occurrence_datetime).getTime();
      const dateB = new Date(b.occurrence_datetime).getTime();

      return dateB - dateA;
    };

    requested.sort(sortByOccurrenceTime);
    checking.sort(sortByOccurrenceTime);
    completed.sort(sortByOccurrenceTime);

    return { requested, checking, completed };
  }, [refreshDataMap]);

  return (
    <>
      <div className="crBox crBox-requested">
        <div className="crTitle">確認要求</div>
        <div className="crContent scrollable">
          {crByStatus.requested.length > 0 ? (
            crByStatus.requested.map((item, i) => <CrBox key={i} cr={item} />)
          ) : (
            <div className="noCr"></div>
          )}
        </div>
      </div>

      <div className="crSeparator" />

      <div className="crBox crBox-checking">
        <div className="crTitle">確認中</div>
        <div className="crContent scrollable">
          {crByStatus.checking.length > 0 ? (
            crByStatus.checking.map((item, i) => <CrBox key={i} cr={item} />)
          ) : (
            <div className="noCr"></div>
          )}
        </div>
      </div>

      <div className="crSeparator" />

      <div className="crBox crBox-completed">
        <div className="crTitle">確認完了</div>
        <div className="crContent scrollable">
          {crByStatus.completed.length > 0 ? (
            crByStatus.completed.map((item, i) => (
              <CrBox key={i} cr={item} isCompleted={true} />
            ))
          ) : (
            <div className="noCr"></div>
          )}
        </div>
      </div>
    </>
  );
};

export default CrStatusList;
